import { has, pickBy } from 'lodash';
import { qs } from '@planjs/utils';

// 扫码登陆
// https://open.work.weixin.qq.com/api/doc/90001/90143/91123
export const WWScanLoginUri =
  'https://open.work.weixin.qq.com/wwopen/sso/3rd_qrConnect?appid=APPID&redirect_uri=REDIRECT_URI&state=STATE&usertype=USERTYPE';

// 授权登陆
// https://work.weixin.qq.com/api/doc/90001/90143/91120
export const WWAuthLoginUri =
  'https://open.weixin.qq.com/connect/oauth2/authorize?appid=APPID&redirect_uri=REDIRECT_URI&response_type=RESPONSE_TYPE&scope=SCOPE&state=STATE#wechat_redirect';

/**
 * 企业微信扫码登陆回调参数
 */
export const WWScanLoginRedirectParamsKey = ['auth_code', 'state', 'appid'];
export const WWAuthLoginRedirectParamsKey = ['code', 'state'];

/**
 * 企业授权应用 扫码登陆
 * @param appId
 * @param useType
 * @param redirectUrl
 * @param state
 */
export function getWWScanLoginUri({
  appId,
  useType = 'member',
  redirectUrl,
  state,
}: {
  appId: string;
  useType?: 'admin' | 'member';
  state: string;
  redirectUrl: string;
}) {
  return WWScanLoginUri.replace('APPID', appId)
    .replace('USERTYPE', useType)
    .replace('STATE', state)
    .replace('REDIRECT_URI', encodeURIComponent(redirectUrl));
}

/**
 * 获取企业微信登陆授权连接
 * @param opt
 */
export function getWWAuthLoginUri(opt: {
  appId: string;
  redirectUrl: string;
  state: string;
  responseType?: 'code';
  scope?: 'snsapi_base' | 'snsapi_userinfo' | 'snsapi_privateinfo';
}) {
  return WWAuthLoginUri.replace('APPID', opt.appId)
    .replace('REDIRECT_URI', opt.redirectUrl)
    .replace('STATE', opt.state)
    .replace('RESPONSE_TYPE', opt.responseType ?? 'code')
    .replace('SCOPE', opt.scope ?? 'snsapi_base');
}

/**
 * 检查是否有企业微信扫码登陆结果
 * @param query
 */
export function hasWWScanLoginRsp(query: Record<string, string>) {
  return WWScanLoginRedirectParamsKey.every((k) => has(query, k));
}

/**
 * 检查是否有企业微信授权登陆结果
 * @param query
 */
export function hasWWAuthLoginRsp(query: Record<string, string>) {
  return WWAuthLoginRedirectParamsKey.every((k) => has(query, k));
}

/**
 * 过滤掉企业微信回调回来的参数，返回 URL
 */
export const getWWSafeRedirectURL = (): URL => {
  const { location } = window;
  const url = new URL(location.origin + location.pathname);
  const search = qs.parse(location.search);

  const filterScanLoginRsp = (obj: any) => {
    return pickBy(
      obj,
      (_, k) => ![...WWScanLoginRedirectParamsKey, ...WWAuthLoginRedirectParamsKey].includes(k),
    );
  };

  url.search = qs.stringify(filterScanLoginRsp(search));
  url.hash = location.hash.split('?')[0];

  const hq = qs.stringify(filterScanLoginRsp(qs.parse(location.hash.split('?').pop()!)));
  if (hq) {
    url.hash += '?' + hq;
  }
  return url;
};
